const selector = "input[data-set-time-zone]"

document.addEventListener("DOMContentLoaded", (e) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const element = document.querySelector(selector)

  if (element) {
    element.value = timeZone
  }
})
